/* eslint-disable max-len */
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

class IconCalendar4 extends React.Component {
  render() {
    const iconClasses = classNames("icon calendar4", this.props.className);
    return (
      <svg
        className={iconClasses}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 30 30"
      >
        <path d="M 6 4 C 4.895 4 4 4.895 4 6 L 4 24 C 4 25.105 4.895 26 6 26 L 24 26 C 25.105 26 26 25.105 26 24 L 26 6 C 26 4.895 25.105 4 24 4 L 6 4 z M 6 6 L 24 6 L 24 10 L 6 10 L 6 6 z M 14.650391 14.498047 L 17.136719 14.498047 L 17.136719 19.005859 L 18.015625 19.005859 L 18.015625 20.400391 L 17.136719 20.400391 L 17.136719 21.544922 L 15.441406 21.544922 L 15.441406 20.400391 L 11.984375 20.400391 L 11.984375 18.902344 C 12.625375 17.676344 13.435391 16.343047 14.650391 14.498047 z M 15.398438 15.777344 C 14.797438 16.705344 14.324203 17.505469 13.533203 18.980469 L 13.533203 19.068359 L 15.486328 19.068359 L 15.486328 15.777344 L 15.398438 15.777344 z" />
      </svg>
    );
  }
}

IconCalendar4.defaultProps = {
  className: null
};

IconCalendar4.propTypes = {
  className: PropTypes.string
};

export default IconCalendar4;
